const ALARM_DASHBOARD_SUBDOMAIN_PREFIX = 'vivo.';
const KNOWN_ROOT_DOMAINS = ['kiper.com.br', 'porter.com.br'];

/**
 * Adapta o domínio raiz do link da aplicação Porter Alarm Dashboard
 * (hostname com prefixo "vivo.") para o domínio raiz em que o usuário
 * acessa o account. Exemplo: acesso via account.cloud.porter.com.br
 * converte https://vivo.cloud.kiper.com.br em https://vivo.cloud.porter.com.br.
 * Qualquer caso não reconhecido retorna a url original.
 */
export const adaptApplicationUrl = mainUrl => {
  if (typeof window === 'undefined' || !mainUrl) return mainUrl;

  try {
    const applicationUrl = new URL(mainUrl);

    if (!applicationUrl.hostname.startsWith(ALARM_DASHBOARD_SUBDOMAIN_PREFIX))
      return mainUrl;

    const currentRootDomain = KNOWN_ROOT_DOMAINS.find(rootDomain =>
      window.location.hostname.endsWith(rootDomain),
    );
    const applicationRootDomain = KNOWN_ROOT_DOMAINS.find(rootDomain =>
      applicationUrl.hostname.endsWith(rootDomain),
    );

    if (
      !currentRootDomain ||
      !applicationRootDomain ||
      currentRootDomain === applicationRootDomain
    )
      return mainUrl;

    applicationUrl.hostname = applicationUrl.hostname.replace(
      applicationRootDomain,
      currentRootDomain,
    );

    return applicationUrl.toString();
  } catch (error) {
    return mainUrl;
  }
};
